import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import UserFormToFill from "./UserFormToFill";




function UserForm () {
    return (
        <>
            <Dummylayout/>
        <BasicCard>
                <UserFormToFill/>
                </BasicCard>
        </>
    )
}
export default UserForm;